<section class="color-label-wrapper Auto_ContextMenu_Color_Label">
  <span [ngClass]="color" class="label-item" *ngFor="let color of colors" (click)="updateEmit($event,color)"></span>
</section>
